import { computed } from "#imports";
import { useWindowSize } from "@vueuse/core";
const { width } = useWindowSize();
const isMobile = computed(() => width.value <= 1024);
export function useAdaptive() {
  return {
    width,
    isMobile
  };
}
